import { X } from 'lucide-react';

interface FileAttachmentListProps {
  files: File[];
  onRemove: (index: number) => void;
}

export const FileAttachmentList = ({ files, onRemove }: FileAttachmentListProps) => {
  if (files.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {files.map((file, i) => (
        <div
          key={i}
          className="flex items-center gap-1 bg-muted px-2 py-1 rounded text-xs text-muted-foreground border border-border"
        >
          <span className="max-w-[100px] truncate">{file.name}</span>
          <button type="button" onClick={() => onRemove(i)}>
            <X className="h-3 w-3 hover:text-destructive" />
          </button>
        </div>
      ))}
    </div>
  );
};
FileAttachmentList.displayName = 'FileAttachmentList';
